import { Leaf, Grape, Citrus, Cherry, Apple, Nut, Wheat, Sprout, Carrot, TreeDeciduous } from 'lucide-react';

export const CROPS = [
  { v: 'olivo', l: 'Olivo', I: Leaf },
  { v: 'vite', l: 'Vite', I: Grape },
  { v: 'agrumi', l: 'Agrumi', I: Citrus },
  { v: 'pesco', l: 'Pesco', I: TreeDeciduous },
  { v: 'ciliegio', l: 'Ciliegio', I: Cherry },
  { v: 'melo', l: 'Melo', I: Apple },
  { v: 'nocciolo', l: 'Nocciolo', I: Nut },
  { v: 'grano', l: 'Grano', I: Wheat },
  { v: 'mais', l: 'Mais', I: Sprout },
  { v: 'ortaggi', l: 'Ortaggi', I: Carrot },
];
export const ARBOREAL = ['olivo', 'vite', 'agrumi', 'pesco', 'ciliegio', 'melo', 'nocciolo'];

export const REGIONS = ['Abruzzo', 'Basilicata', 'Calabria', 'Campania', 'Emilia-Romagna', 'Friuli-Venezia Giulia', 'Lazio', 'Liguria', 'Lombardia', 'Marche', 'Molise', 'Piemonte', 'Puglia', 'Sardegna', 'Sicilia', 'Toscana', 'Trentino-Alto Adige', 'Umbria', "Valle d'Aosta", 'Veneto'];

export const IRRIGATION = [
  { v: 'rainfed', l: 'In asciutto (nessuna irrigazione)' },
  { v: 'drip', l: 'A goccia' },
  { v: 'sprinkler', l: 'A pioggia / aspersione' },
  { v: 'flood', l: 'A scorrimento' },
];
export const MANAGEMENT = [
  { v: 'conventional', l: 'Convenzionale' },
  { v: 'integrated', l: 'Lotta integrata' },
  { v: 'organic', l: 'Biologico certificato' },
];
export const PRUNING = [
  { v: 'annual', l: 'Potatura annuale' },
  { v: 'biennial', l: 'Potatura biennale (standard)' },
  { v: 'none', l: 'Nessuna potatura regolare' },
];

export const STAGES = [
  { k: 'region', l: 'Riconoscimento regione' },
  { k: 'baseline', l: 'Rese di riferimento ISTAT' },
  { k: 'climate', l: 'Clima 10 anni e topografia' },
  { k: 'season', l: 'Meteo reale di quest\'anno' },
  { k: 'vision', l: 'Analisi AI delle foto' },
  { k: 'fusion', l: 'Calcolo finale, valore in € e scenari' },
];

export const CONFIDENCE_TONE = {
  alta: 'bg-chartreuse/20 text-chartreuse border-chartreuse/40',
  media: 'bg-terracotta/20 text-terracotta border-terracotta/40',
  bassa: 'bg-secondary text-muted-foreground border-border',
};
export const BENCHMARK_TONE = {
  'Eccellente': 'bg-chartreuse/20 text-chartreuse border-chartreuse/40',
  'Sopra media': 'bg-chartreuse/10 text-chartreuse border-chartreuse/30',
  'Sotto media': 'bg-terracotta/15 text-terracotta border-terracotta/40',
  'Critico': 'bg-destructive/20 text-destructive border-destructive/40',
};

export const formatEuro = (n) => `€ ${new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0 }).format(n || 0)}`;
export const formatQ = (n) => `${new Intl.NumberFormat('it-IT', { maximumFractionDigits: 1 }).format(n || 0)} q`;
